import { AbstractAuthorData, AbstractAuthorSchema } from ".";
import * as yup from "yup";
import { ReactSelectOption } from "../../models/generic";
import { FormValidationModel } from "../../models/validation";
import { ReactSelectOptionSchema } from "../generic";

export interface AbstractAuthorshipData {
    abstractId: number;
    authors: AbstractAuthorData[];
    keywords: Array<ReactSelectOption | null>;
    studyGroup?: string;
    title: string;
    typeId?: number;
}

export class AbstractAuthorship implements FormValidationModel<AbstractAuthorshipData> {
    public data: AbstractAuthorshipData;
    public rules: yup.Schema<AbstractAuthorshipData>;

    public constructor() {
        this.data = {
            abstractId: 0,
            authors: [],
            keywords: [],
            title: "",
        };
        this.rules = yup.object<AbstractAuthorshipData>().shape({
            abstractId: yup.number().required().label("Abstract ID").min(0, "Invalid $label"),
            authors: yup.array().of(AbstractAuthorSchema).label("Authors"),
            keywords:  yup.array().of(ReactSelectOptionSchema).nullable(true).label("Keywords"),
            studyGroup: yup.string().label("Study group").max(4000),
            title: yup.string().required().label("Title").max(200, "$label may not exceed ${max} characters"),
            typeId: yup.number().required().label("Presentation format").nullable(true).min(1, "invalid $label"),
        });
    }
}



// WEBPACK FOOTER //
// ./src/forms/adminAbstracts/AbstractAuthorship.ts